import { get } from 'lodash';
import React from 'react';
import { FieldArray, useFormikContext } from 'formik';

import { LayoutBox, Flex, Delimiter, Button } from 'src/kit';
import { Title, RemoveButton, AddButton, FormikSubmitButton } from '@src/features/common';
import { getDefaultEducation } from './validationSchema';
import { Education } from './Education';

const EducationsForm = ({ resourcesStore, isAnonymousJob, initialValues, goToNextStep }: any) => {
  const { values, errors, isSubmitting, setFieldValue } = useFormikContext();

  const handleSkip = () => {
    setFieldValue('degrees_attributes', []);
    goToNextStep();
  };

  return (
    <div>
      {Boolean(initialValues.degrees_attributes?.length) && (
        <>
          <Title>Fill your Education history</Title>
          <Delimiter my={30} />
        </>
      )}
      <FieldArray name="degrees_attributes">
        {arrayHelpers => (
          <div>
            <LayoutBox mb={20} rowGap={50}>
              {values.degrees_attributes.map((degree, index, array) => (
                <Flex key={degree.id || degree.cid}>
                  <Education
                    resourcesStore={resourcesStore}
                    index={index}
                    degreeValues={get(values, `degrees_attributes.${index}`, {})}
                    errors={errors}
                    setFieldValue={setFieldValue}
                  />
                  {array.length > 1 && <RemoveButton onClick={() => arrayHelpers.remove(index)} />}
                </Flex>
              ))}
            </LayoutBox>
            <AddButton onClick={() => arrayHelpers.push(getDefaultEducation())}>Add another institution</AddButton>
          </div>
        )}
      </FieldArray>
      <Flex justifyContent="flex-end" mr="120px">
        {isAnonymousJob && (
          <Button onClick={handleSkip} mr={20} variant="cancel" size="md">
            Skip
          </Button>
        )}
        <FormikSubmitButton variant="primary" size="md">
          {isSubmitting ? 'Validating' : 'Validate'}
        </FormikSubmitButton>
      </Flex>
    </div>
  );
};

export default EducationsForm;
